<template>
  <div>
    <div class="back">
      <span class="back-text" @click="$router.back()">首页</span>
      <img class="back-image" src="@/assets/img/icon/Union.png" alt="" />
      <span class="back-model">{{ query.paperType }}</span>
    </div>
    <div class="page-con" v-loading="loading">
      <!-- 左边题目 -->
      <div class="paper-con">
        <div v-for="item in subjectList" :key="item.id">
          <template v-if="activeTopic == item.sort">
            <div class="con-item">
              <div class="item-tit">
                <span class="tit-name">{{ item.contentType }}</span>
                <span class="tit-num">
                  <span style="color: #00b861"> {{ item.sort }}</span
                  >/ {{ subjectList.length }}</span
                >
              </div>
              <div class="item-con">
                <div class="question-content" v-if="item.contentData">
                  {{ item.contentData }}
                </div>
                <div class="question-title" v-html="topicTitle(item)"></div>
                <div
                  class="question-option"
                  v-for="(op, i) in item.options"
                  :key="i"
                >
                  <div style="margin-right: 8px">{{ op.label }}</div>
                  <div v-html="op.value"></div>
                </div>
              </div>
            </div>
            <div class="con-options">
              <div class="options" v-if="item.logicType !== '填空'">
                请选择：
                <div
                  class="option"
                  :class="{
                    active:
                      item.logicType === '多选'
                        ? item.studentAnswer.indexOf(op.label) > -1
                        : item.studentAnswer == op.label,
                    right: item.answer === item.studentAnswer && disabled,
                    error: item.answer !== item.studentAnswer && disabled,
                  }"
                  @click="handleSelect(item, op)"
                  v-for="(op, i) in item.options"
                  :key="i"
                >
                  {{ op.label }}
                </div>
              </div>
              <div class="not-dt" v-else>此题暂不支持作答</div>
              <div class="handle">
                <div class="time">
                  <img
                    class="img"
                    src="../../assets/img/icon/time.png"
                    alt=""
                  />
                  <span class="txt">{{ $Tools.time_h(timingTime) }}</span>
                </div>
                <div class="btns">
                  <div class="btn analysis" @click="handleAnalysis">
                    {{ showAnalysis ? "隐藏解析" : "查看解析" }}
                  </div>
                  <div class="btn" @click="handleBack" style="margin: 0 8px">
                    上一题
                  </div>
                  <div class="btn" @click="handleGo">下一题</div>
                </div>
              </div>
            </div>
            <div class="con-analysis" v-if="showAnalysis">
              <div class="ana-tit">
                <div>正确答案：</div>
                <div v-html="item.answer"></div>
              </div>
              <div class="ana-text">答案解析</div>
              <div class="ana-con" v-html="item.analysis"></div>
            </div>
          </template>
        </div>
      </div>
      <!-- 右边答题卡 -->
      <div class="paper-scantron">
        <div class="scantron-tit">
          <div class="tt-name">{{ query.name }}</div>
          <div class="tt-btn" v-if="disabled" @click="reInit">重测</div>

          <div class="tt-btn" v-else @click="openHandleDialog">交卷</div>
        </div>
        <div
          class="card-result"
          :class="showToggle ? 'hid' : ''"
          v-if="disabled"
        >
          <div class="result-tit">
            <div>
              <span class="tt">测试结果</span>
              <span class="score">总得分：{{ rightTotal }}分</span>
            </div>
            <div class="handle-toggle" @click="showToggle = !showToggle">
              {{ showToggle ? "展开" : "收缩"
              }}<i
                v-if="showToggle"
                class="el-select__caret el-input__icon el-icon-arrow-up"
              ></i
              ><i
                v-else
                class="el-select__caret el-input__icon el-icon-arrow-down"
              ></i>
            </div>
          </div>
          <div class="result-info">
            <div class="info-per">
              <Progress
                :percentage="resultInfo.rightRate"
                :shade="['#FFAF3A', '#FFAF3A']"
              />
            </div>
            <div class="text-info">
              <div class="text-item">
                <div>{{ $Tools.time_h(resultInfo.exerciseTime) }}</div>
                <div>练习时间</div>
              </div>
              <div class="text-item">
                <div>{{ resultInfo.wrongCount }}</div>
                <div>错题数</div>
              </div>
              <div class="text-item">
                <div>{{ resultInfo.finishCount }}</div>
                <div>本次答题数</div>
              </div>
            </div>
          </div>
          <div class="result-in" v-if="true">
            <div class="result-table">
              <div class="table-tit">
                <div class="t1">题干</div>
                <div class="t2">总数目/分值</div>
                <div class="t2">答对数目/得分</div>
              </div>
              <div class="table-item" v-for="(item, i) in sheetList" :key="i">
                <div class="t1">{{ item.contentType }}</div>
                <div class="t2">{{ item.subjects.length }}</div>
                <div class="t2">{{ totalScore(item) }}</div>
                <template v-if="item.subjects[0].logicType == '填空'">
                  <div class="t3">暂不支持作答</div>
                </template>
                <template v-else>
                  <div class="t2 count">{{ rightCount(item) }}</div>
                  <div class="t2 score">{{ rightScore(item) }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="scantron-card">
          <div class="card-name">答题卡</div>
          <div class="card-btns">
            <div class="btn-item">
              <div class="btn-dot"></div>
              <div class="btn-text">不可作答</div>
            </div>
            <div class="btn-item">
              <div class="btn-dot finished"></div>
              <div class="btn-text">已做</div>
            </div>
          </div>
        </div>

        <div class="card-con">
          <div class="card-item" v-for="(item, i) in sheetList" :key="i">
            <div class="item-tit">
              <span class="tit-name">{{ item.contentType }}</span>
              <span class="tit-finished">{{ setItemCount(item) }}</span> /
              {{ item.subjects.length }}
            </div>
            <div class="item-options">
              <div
                class="item-option"
                @click="handleTurn(el.sort)"
                :class="{
                  finished: el.studentAnswer,
                  disabled: el.logicType === '填空',
                  selected: el.sort == activeTopic,
                  right:
                    el.studentAnswer === el.answer &&
                    disabled &&
                    el.logicType !== '填空',
                  error:
                    el.studentAnswer !== el.answer &&
                    disabled &&
                    el.logicType !== '填空',
                }"
                v-for="el in item.subjects"
                :key="el.id"
              >
                {{ el.sort }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      ref="dialog"
      :count="totalCount - selTotal"
      @submit="submitAnswer"
    />
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
import Dialog from "./Dialog";
import Progress from "./Progress";
export default {
  mixins: [page_mx],

  data() {
    return {
      timingTimer: null,
      timingTime: 0,
      disabled: false,
      loading: false,
      showAnalysis: false,
      showToggle: false,
      activeTopic: 1,
      resultInfo: {},
      sheetList: [],
      subjectList: [],
    };
  },
  components: {
    Dialog,
    Progress,
  },
  computed: {
    setItemCount() {
      return (item) => {
        let count = 0;
        item.subjects.forEach((el) => {
          if (el.studentAnswer) count++;
        });
        return count;
      };
    },
    rightCount() {
      return (item) => {
        let count = 0;
        item.subjects.forEach((el) => {
          if (el.studentAnswer == el.answer) count++;
        });
        return count;
      };
    },
    rightTotal() {
      let total = 0;
      this.subjectList.forEach((el) => {
        if (el.studentAnswer == el.answer) total += el.score;
      });
      return total;
    },
    rightScore() {
      return (item) => {
        let count = 0;
        item.subjects.forEach((el) => {
          if (el.studentAnswer == el.answer) count += el.score;
        });
        return count;
      };
    },
    totalScore() {
      return (item) => {
        let count = 0;
        item.subjects.forEach((el) => {
          count += el.score;
        });
        return count;
      };
    },
    topicTitle() {
      return (item) => {
        return item.sort + "." + item.content;
      };
    },
    // 题目总数
    totalCount() {
      let total = 0;
      this.subjectList.forEach(() => {
        total++;
      });
      console.log(total, "zongtotal");
      return total;
    },
    // 已经答的数量
    selTotal() {
      let total = 0;
      this.subjectList.forEach((item) => {
        if (item.logicType === "多选") {
          if (item.studentAnswer.length) total++;
        } else {
          if (item.studentAnswer) total++;
        }
      });
      console.log(total, "datotal");
      return total;
    },
  },
  methods: {
    // 初始化
    async init() {
      this.disabled = false;
      this.loading = true;
      this.$api.cms.resource.subject_detailsByPaperForClient
        .get({
          exerciseId: this.query.exerciseId,
          paperId: this.query.paperId,
          paperType: this.query.paperType,
          type: this.query.type,
        })
        .then((res) => {
          this.loading = false;
          this.info = res.data;
          this.organizeData(this.info);
          // 启动正计时
          this.startTiming();
        });
    },
    reInit() {
      this.disabled = false;
      this.loading = true;
      this.activeTopic = 1;
      this.$api.cms.resource.subject_detailsByPaperForClient
        .get({
          exerciseId: "",
          paperId: this.query.paperId,
          paperType: this.query.paperType,
          type: this.query.type,
        })
        .then((res) => {
          this.loading = false;
          this.info = res.data;
          this.organizeData(this.info);
          // 启动正计时
          this.startTiming();
        });
    },
    /**
     * 整理数据
     */
    // 整理数据
    organizeData({ contentMap, typeSubjects }) {
      console.log(contentMap, "contentMap");
      const subjectList = [];
      const sheetList = [];
      let sort = 1;

      for (const item of typeSubjects) {
        // 大题
        const subjects = [];
        // const bigSubjects = {};
        const sheetSubjects = [];

        for (const subItem of item.subjects) {
          // 小题
          const dataItem = this.organizeSubject({
            ...subItem,
            contentData: contentMap[subItem.contentId],
            sort,
          });
          subjects.push(dataItem);
          // if (subItem.contentId === "0") {
          //   // 没有题干
          //   subjects.push(dataItem);
          // } else {
          //   // 有题干
          //   if (!bigSubjects[subItem.contentId]) {
          //     bigSubjects[subItem.contentId] = [];
          //   }
          //   bigSubjects[subItem.contentId].push(dataItem);
          // }

          // 添加到答题卡
          sheetSubjects.push(dataItem);
          sort++;
        }

        // 添加到答题卡
        sheetList.push({
          contentType: item.contentType,
          subjects: sheetSubjects,
        });

        // 提取普通题目
        if (subjects.length) {
          subjectList.push(...subjects);
        }
        // console.log(bigSubjects, "bigSubjects");
        // 提取有题干的题目
        // if (Object.keys(bigSubjects).length) {
        //   console.log(contentMap, "contentMap");
        //   for (const contentId in bigSubjects) {
        //     subjectList.push({
        //       contentType: item.contentType,
        //       content: contentMap[contentId],
        //       subjects: bigSubjects[contentId],
        //       current: 0,
        //     });
        //   }
        // }
      }

      console.log(subjectList, "subjectList");

      this.sheetList = sheetList;
      console.log(sheetList, "sheetList");
      this.subjectList = subjectList;
    },
    // 整理单道题目
    organizeSubject(item) {
      const obj = {
        id: item.id,
        sort: item.sort,
        logicType: item.logicType,
        contentType: item.contentType,
        content: item.content,
        contentData: item.contentData,
        contentId: item.contentId,
        analysis: item.analysis,
        answer: item.answer,
        collectStatus: item.collectStatus,
        status: item.status,
        score: item.score ? item.score : 0,
        studentScore: item.studentScore ? item.studentScore : 0,
        readStatus: item.readStatus === "已阅卷",
        studentAnswer: item.studentAnswer,
        checkAnswer: this.checkAnswer,
      };

      if (item.logicType === "单选") {
        obj.options = this.organizeOptions(item);
      } else if (item.logicType === "多选") {
        if (obj.studentAnswer) {
          obj.studentAnswer = obj.studentAnswer.split("");
        } else {
          obj.studentAnswer = [];
        }
        obj.options = this.organizeOptions(item);
      } else if (item.logicType === "判断") {
        obj.options = [
          { label: "T", value: "正确" },
          { label: "F", value: "错误" },
        ];
      } else if (item.logicType === "填空") {
        if (obj.studentAnswer) {
          obj.studentAnswer = decodeURIComponent(obj.studentAnswer);
        }
      }
      return obj;
    },
    // 整理题目选项
    organizeOptions(item) {
      const labels = ["A", "B", "C", "D", "E", "F", "G", "H", "I"];
      const options = [];

      for (const label of labels) {
        if (item["answer" + label]) {
          options.push({
            label,
            value: item["answer" + label],
          });
        }
      }
      return options;
    },

    /*
      答题
    */
    // 选择答案
    handleSelect(item, op) {
      if (this.disabled) return;

      if (this.logicType === "多选") {
        const studentAnswer = [...this.studentAnswer];
        const ind = studentAnswer.indexOf(op.label);
        if (ind > -1) {
          studentAnswer.splice(ind, 1);
        } else {
          studentAnswer.push(op.label);
        }
        this.$set(item, "studentAnswer", studentAnswer);
        // item.studentAnswer = studentAnswer;
        // this.$emit("studentAnswerChange", studentAnswer);
      } else {
        // this.$emit("studentAnswerChange", item.label);
        this.$set(item, "studentAnswer", op.label);
      }
      console.log(this.subjectList, "subjectList");
      console.log(this.sheetList, "sheetList");
    },
    openHandleDialog() {
      const count = this.totalCount - this.selTotal;
      if (count) {
        this.$refs.dialog.openDialog();
        return;
      }
      this.$Tools.confirm("是否确认交卷?").then(async () => {
        this.submitAnswer();
      });
    },
    // 提取答案
    extractAnswers() {
      const subjectIds = [];
      const answers = [];

      for (const item of this.subjectList) {
        // 没有题干
        if (item.logicType === "多选") {
          if (item.studentAnswer.length) {
            subjectIds.push(item.id);
            answers.push(item.studentAnswer.join(""));
          }
        } else if (item.studentAnswer) {
          subjectIds.push(item.id);
          answers.push(item.studentAnswer);

          // if (item.logicType === "填空") {
          //   answers.push("");
          // } else {
          //   answers.push(item.studentAnswer);
          // }
        }
      }

      return {
        subjectIds,
        answers,
      };
    },

    // 交卷
    submitAnswer() {
      const count = this.totalCount - this.selTotal;

      console.log(this.subjectList, "subjectList Ansser");
      console.log(this.sheetList, "sheetList Ansser");

      const data = this.extractAnswers();
      const { answers, subjectIds } = data;
      console.log(data, "data");
      this.$api.sms.study.studentSubject_handSubject
        .post({
          answers: answers.join(","),
          subjectIds: subjectIds.join(","),
          belongId: this.query.paperId,
          courseId: this.query.courseId,
          exerciseTime: this.timingTime,
          latestExerciseId: this.query.exerciseId,
          type: this.query.paperType,
        })
        .then((res) => {
          this.$message.success("提交成功");
          if (count == 0) {
            this.disabled = true;
            this.showAnalysis2 = true;
            this.showToggle = false;
            clearInterval(this.timingTimer);

            this.$api.sms.study.studentExercise_detailForClient
              .get({
                id: res.data,
              })
              .then((result) => {
                this.resultInfo = result.data;
                console.log(result, "resutl");
              });
          } else {
            this.$router.push("/");
          }
        });
    },

    /*
      跳转相关
    */
    handleGo() {
      if (this.activeTopic == this.subjectList.length) return;
      this.showAnalysis = false;
      this.activeTopic++;
      this.handleAnswer();
    },
    handleBack() {
      if (this.activeTopic == 1) return;
      this.showAnalysis = false;
      this.activeTopic--;
      this.handleAnswer();
    },
    handleTurn(num) {
      this.activeTopic = num;
      this.showAnalysis = false;
      this.handleAnswer();
    },

    // 设置填空题点击就有答案
    handleAnswer() {
      const obj = this.subjectList.find((item) => {
        return item.sort == this.activeTopic;
      });
      if (obj.logicType === "填空" && !this.disabled) {
        this.$set(obj, "studentAnswer", "**completion**");
      }
      console.log(obj, "obj");
    },

    handleAnalysis() {
      this.showAnalysis = !this.showAnalysis;
    },

    /*
      计时相关
    */
    // 启动正计时
    startTiming() {
      this.timingTime = 0;
      clearInterval(this.timingTimer);
      this.timingTimer = setInterval(() => {
        this.timingTime += 1;
      }, 1000);
    },
  },
  destroyed() {
    // 停止正计时
    clearInterval(this.timingTimer);
  },
};
</script>
<style lang="less" scope>
.back {
  width: 1160px;
  margin: 8px auto 0;
  display: flex;
  align-items: center;
  &-image {
    margin: 0 10px;
    vertical-align: middle;
  }
  &-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
  &-model {
    color: #01002c;
  }
}
.page-con {
  margin: 7px auto;
  width: 1160px;
  display: flex;
  .paper-con {
    width: 756px;
    .con-item {
      padding: 30px 20px;
      height: 460px;
      border-radius: 8px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.11);
      .item-tit {
        margin-bottom: 20px;
        .tit-name {
          font-size: 18px;
          font-weight: bold;
          line-height: 26px;
          color: #333;
        }
        .tit-num {
          color: #a8aab8;
          font-size: 14px;
        }
      }
      .item-con {
        height: 360px;
        overflow-y: auto;
        .question-content {
          font-size: 14px;
          line-height: 150%;
          color: #686876;
        }
        .question-title {
          margin: 20px 0;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
        }
        .question-option {
          display: flex;
          align-items: center;
          margin-top: 12px;
          font-size: 16px;
          line-height: 24px;
          color: #686876;
        }
      }
    }
    .con-options {
      margin-top: 16px;
      padding: 30px 20px;
      height: 144px;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.11);
      box-sizing: border-box;
      .not-dt {
        font-size: 16px;
        line-height: 24px;
        text-align: right;
        color: #a8aab8;
      }
      .options {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 16px;
        color: #333;
        .option {
          margin-left: 16px;
          width: 32px;
          height: 32px;
          border-radius: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
          box-sizing: border-box;
          border: 1px solid #d6dedd;
          cursor: pointer;
        }
        .option.active {
          background: #3480ff;
          color: #fff;
          border: 1px solid #3480ff;
        }
        .option.active.right {
          background-color: #00b861;
          border-color: #00b861;
        }
        .option.active.error {
          background-color: #ff5536;
          border-color: #ff5536;
        }
        .option:hover {
          opacity: 0.8;
        }
      }
      .handle {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .time {
          display: flex;
          align-items: center;
          .img {
            margin-right: 6px;
            width: 20px;
            height: 20px;
          }
          .txt {
            font-size: 16px;
            color: #a8aab8;
          }
        }
        .btns {
          display: flex;
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 32px;
            font-size: 14px;
            cursor: pointer;
            border-radius: 16px;
            background: #ffffff;
            box-sizing: border-box;
            border: 1px solid #00b861;
            color: #00b861;
          }
          .btn:hover {
            border: 1px solid #33c681;
            color: #33c681;
          }
          .btn.analysis {
            color: #ab8049;
            border: 1px solid #ab8049;
          }
          .btn.analysis:hover {
            color: #bc996d;
            border: 1px solid #bc996d;
          }
        }
      }
    }
    .con-analysis {
      margin-top: 16px;
      padding: 30px 20px;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.11);
      .ana-tit {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #00b861;
        font-weight: bold;
      }
      .ana-text {
        padding-top: 20px;
        font-size: 18px;
        color: #ab8049;
        font-weight: bold;
      }
      .ana-con {
        padding-top: 12px;
        font-size: 16px;
        line-height: 24px;
        color: #ab8049;
      }
    }
  }
  .paper-scantron {
    margin-left: 16px;
    padding: 30px 20px;
    width: 388px;
    box-sizing: border-box;
    min-height: 600px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.11);
    .scantron-tit {
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #d6dedd;
      .tt-name {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
      .tt-btn {
        width: 64px;
        height: 26px;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #00b861;
        font-size: 14px;
        cursor: pointer;
        color: #fff;
      }
      .tt-btn:hover {
        background: #33c681;
      }
    }
    .scantron-card {
      padding-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-name {
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .card-btns {
        display: flex;
        .btn-item {
          margin-left: 12px;
          display: flex;
          align-items: center;
          .btn-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #cdd0e0;
          }
          .btn-dot.finished {
            background: #3480ff;
          }
          .btn-text {
            padding-left: 8px;
            font-size: 12px;
            color: #686876;
          }
        }
      }
    }
    .card-result {
      padding-bottom: 20px;
      border-bottom: 1px solid #d6dedd;
      .result-tit {
        padding-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tt {
          font-weight: bold;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
        }
        .score {
          padding-left: 8px;
          font-size: 14px;
          color: #ffaf3a;
        }
        .handle-toggle {
          font-size: 12px;
          color: #a8aab8;
          cursor: pointer;
        }
        .handle-toggle:hover {
          color: #333;
        }
      }
      .result-info {
        padding-top: 10px;
        display: flex;
        align-items: center;
        .info-per {
          margin-right: 30px;
        }
        .text-info {
          display: flex;
          align-items: center;
          .text-item {
            margin-left: 16px;
            text-align: center;
            width: 72px;
          }
        }
      }
      .result-table {
        margin-top: 20px;
        // width: 340px;
        border: 1px solid #a8aab8;
        border-radius: 12px;
        box-sizing: border-box;
        .table-tit {
          display: flex;
          height: 48px;
          line-height: 48px;
          font-weight: bold;
          font-size: 12px;
          color: #01002c;
          border-bottom: 1px solid #a8aab8;
          .t1 {
            padding-left: 16px;
            width: 128px;
            box-sizing: border-box;
          }
          .t2 {
            border-left: 1px solid #a8aab8;
            width: 108px;
            text-align: center;
            box-sizing: border-box;
          }
        }
        .table-item {
          display: flex;
          height: 48px;
          line-height: 48px;
          font-size: 12px;
          color: #01002c;
          border-bottom: 1px solid #a8aab8;

          .t1 {
            padding-left: 16px;
            width: 128px;
            box-sizing: border-box;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .t2 {
            width: 54px;
            text-align: center;
            border-left: 1px solid #a8aab8;
            box-sizing: border-box;
          }
          .t3 {
            width: 108px;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #a8aab8;
            color: #a8aab8;
          }
          .t2.count {
            color: #00c15d;
          }
          .t2.score {
            color: #ffaf3a;
          }
        }
        .table-item:last-child {
          border-bottom: none;
        }
      }
    }
    .card-result.hid {
      height: 30px;
      overflow: hidden;
    }
    .card-con {
      .card-item {
        padding-top: 20px;
        max-height: 600px;
        overflow-y: auto;
        .item-tit {
          font-size: 14px;
          color: #a8aab8;
          .tit-name {
            color: #686876;
          }
          .tit-finished {
            padding-left: 8px;
            color: #3480ff;
          }
        }
        .item-options {
          padding-top: 12px;
          display: flex;
          flex-wrap: wrap;
          .item-option {
            margin-right: 12px;
            margin-bottom: 12px;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            font-size: 12px;
            color: #333;
            border: 1px solid #d6dedd;
            box-sizing: border-box;
            cursor: pointer;
          }

          .item-option.disabled {
            background: #f0f2f6;
            border: none;
            color: #a8aab8;
          }
          .item-option.selected {
            background: rgba(52, 128, 255, 0.1);
            color: #3480ff;
            border: 1px solid #9bc0ff;
          }
          .item-option.finished {
            background: #3480ff;
            border: none;
            color: #fff;
          }

          .item-option.right {
            background: #00b861;
          }
          .item-option.error {
            background: #ff5536;
          }
          .item-option:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
